import moment from "moment";

class ABW {
  constructor() {
    this.pond_id = "";
    this.last_abw = 0;
    this.last_abw_date = "--";
    this.present_date = moment();
    this.samples = [new Samples()];
    this.abw = 1;
    this.weight_gain = undefined;
    this.survival_percentage = 100;
  }
}
class Samples {
  constructor() {
    this.name = "Sample";
    this.weight = undefined;
    this.no_of_shrimps = undefined;
    this.abw = 1;
  }
}
export { ABW, Samples };
